<template>
    <section class="faq">
        <div class="faq-item" v-for="(item, index) in items" :key="index">
            <div class="faq-trigger" @click="toggle(index)">
                <span>{{ item.question }}</span>
                <b-icon class="chevron" :icon="openIndex === index ? 'caret-up' : 'caret-down'" pack="fas" />
            </div>
            <transition @enter="enter" @after-enter="afterEnter" @leave="leave">
                <div class="faq-answer-wrapper" v-show="openIndex === index">
                    <div class="faq-answer" v-html="item.answer"></div>
                </div>
            </transition>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.faq {
    max-width: 800px;
    margin: 0 auto;
    text-align: left;

    .faq-item {
        border-bottom: 1px solid $gray-light;

        &:last-child {
            border-bottom: none;
        }
    }

    .faq-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 4px;
        cursor: pointer;
        font-weight: bold;

        .chevron {
            color: $gray;
            flex-shrink: 0;
            margin-left: 12px;
        }
    }

    .faq-answer-wrapper {
        height: 0;
        overflow: hidden;
        transition: height 0.25s ease;
    }

    .faq-answer {
        padding: 0 4px 14px;
        color: $gray-dark;
        font-size: 0.9rem;
        line-height: 1.6;

        ::v-deep code {
            background: $gray-light;
            border-radius: 3px;
            padding: 1px 6px;
        }
    }
}
</style>

<script>
export default {
    name: 'DocsFaq',
    data() {
        return {
            openIndex: 0,
            items: [
                {
                    question: 'What is Gamebot?',
                    answer: 'Gamebot is a free Discord bot for playing multiplayer games with your server, including Anagrams, Cards Against Humanity, Chess, Connect 4, Othello, Poker, Survey Says, and Wisecracks. It runs entirely through Discord slash commands, no extra apps or downloads required.',
                },
                {
                    question: 'Is Gamebot free to use?',
                    answer: 'Yes, Gamebot is free to use. An optional shop offers cosmetic items and a premium gold currency, but nothing is required to play.',
                },
                {
                    question: 'How do I add Gamebot to my Discord server?',
                    answer: 'Click <b>Add to Discord</b>, choose the server you want to add it to, and authorize the bot. You\'ll need permission to add bots to that server. Once Gamebot joins, type <code>/help</code> in any channel to get started.',
                },
                {
                    question: 'What games can I play with Gamebot?',
                    answer: 'Gamebot currently supports nine games: Anagrams, Cards Against Humanity, Cards Against Humanity: Family Edition, Chess, Connect 4, Othello, Poker, Survey Says, and Wisecracks. Run <code>/gamelist</code> in Discord to see them all, or check the Playing a Game section above.',
                },
                {
                    question: 'Does Gamebot work on mobile?',
                    answer: 'Yes. Gamebot works anywhere Discord does, including the Discord app for iOS and Android, since every command and game runs through Discord itself.',
                },
                {
                    question: 'What makes Gamebot a great choice for Discord game nights?',
                    answer: 'Gamebot brings a full library of party, card, and board games into one bot, with no separate downloads, logins, or tabs. It\'s built specifically for groups, making it a natural fit for running regular game nights, tournaments, and community events on Discord.',
                },
                {
                    question: 'How do I use Gamebot\'s commands?',
                    answer: 'Gamebot uses Discord slash commands, so just type <code>/</code> in any channel where the bot is present and pick a command from the menu, like <code>/play</code>.',
                },
                {
                    question: 'Do I need any special permissions to play?',
                    answer: 'No, any server member can start a game with <code>/play</code>. A few commands, like force-stopping a game, are restricted to Gamebot\'s own team and aren\'t available to regular server moderators.',
                },
                {
                    question: 'Can I play Gamebot in a DM?',
                    answer: 'A few commands support DMs (like <code>/help</code> and <code>/gamelist</code>), but most games need a server text channel since they\'re built for groups.',
                },
                {
                    question: 'What\'s the difference between credits and gold?',
                    answer: 'Credits are earned by playing and voting for the bot, and are used in the shop for cosmetics. Gold is a premium currency for exclusive items, see <code>/shop</code> for details.',
                },
                {
                    question: 'How do XP, levels, and achievements work?',
                    answer: 'You earn XP for playing games, which levels up your profile over time. Achievements unlock for specific milestones. Check your progress anytime with <code>/profile</code>.',
                },
                {
                    question: 'A game seems stuck, how do I fix it?',
                    answer: 'Wait for the game to time out automatically, or report it in our <a href="/discord" target="_blank">support server</a> and one of our moderators can force-stop it for you.',
                },
            ],
        }
    },
    methods: {
        toggle(index) {
            this.openIndex = this.openIndex === index ? -1 : index
        },
        enter(el) {
            el.style.height = '0'
            // eslint-disable-next-line no-unused-expressions
            el.offsetHeight
            el.style.height = `${el.scrollHeight}px`
        },
        afterEnter(el) {
            el.style.height = 'auto'
        },
        leave(el) {
            el.style.height = `${el.scrollHeight}px`
            // eslint-disable-next-line no-unused-expressions
            el.offsetHeight
            el.style.height = '0'
        },
    },
}
</script>
